import script from "./FeedbackEntrance.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackEntrance.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackEntrance.vue?vue&type=style&index=0&id=624dd812&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-624dd812"]])

export default __exports__